import React from 'react';
import { Link } from 'gatsby';
import MainMenuItem from './mainMenuItem';
import { LinkWrapper } from '../../../utils/link';

const DesktopMenu = ({ params }) => {
  const {
    logo,
    navigation,
    secondary_navigation,
    buttonStyle,
    visibleIndex,
    setVisible,
  } = params;

  return (
    <nav className="w-full lg:sticky top-0 z-80 bg-white -mb-4">
      <div className=" max-w-screen-xl w-full mx-auto rounded-b flex justify-between items-center  py-4 px-4 md:px-12 ">
        <div className="flex">
          <Link to="/" aria-label="Start" data-tracking-id="main-menu-logo">
            <span className="sr-only">{logo.alt}</span>
            <img
              className="h-11 min-w-[155px] z-20 relative"
              src={logo.filename}
              alt={logo.alt}
            />
          </Link>
          <div className="ml-6 text-normal mt-2 hidden lg:flex items-center">
            {navigation.map((nav, index) => (
              <MainMenuItem
                nav={nav}
                index={index}
                key={nav._uid}
                className={buttonStyle}
                visibleIndex={visibleIndex}
                setVisible={setVisible}
              />
            ))}
          </div>
        </div>
        <div className="ml-3 hidden lg:flex">
          {secondary_navigation.map((item) => {
            const hide_text = item.hide_text;
            return (
              <div
                className={`flex flex-nowrap content-center items-center ml-1 ${
                  hide_text ? 'px-4' : 'pl-5 pr-4'
                } py-2 rounded-full border border-transparent hover:border-black/50 transition-border duration-300 ease-in-out text-base font-crystalCondensed whitespace-nowrap relative z-20 mt-2`}
                key={item._uid}
              >
                <LinkWrapper
                  link={item.link}
                  className="flex no-underline content-center"
                  trackingId={`main-menu-${item.text}`}
                >
                  {!hide_text && item.text}
                  <img
                    src={item.image.filename}
                    className={`max-h-5 ${hide_text ? '' : 'ml-2'}`}
                    alt={item.text}
                  />
                </LinkWrapper>
              </div>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default DesktopMenu;
